<template>
  <a-layout>
    <a-layout-header id="HomePage">
      <div class="right" style="float:right">
        <a-button type="primary" @click="startProject">开始设计</a-button>
        <a-input-search
          placeholder="搜索订单号"
          style="width: 200px;margin:0 30px;"
          allow-clear
          v-model="keyword"
          :loading="searching"
          @search="onSearch"
        />
        <user-info />
      </div>
      <div class="logo">
        <img src="@/assets/logo.png">
      </div>
      <a-menu
        class="menu"
        theme="dark"
        mode="horizontal"
        :style="{ lineHeight: '64px' }"
      >
        <a-menu-item key="1">
          我的设计空间
        </a-menu-item>
      </a-menu>
    </a-layout-header>

    <a-layout-content style="padding: 0 50px">
      <div :style="{ background: '#fff', padding: '24px', minHeight: '280px' }">
        <template v-if="!displaySearchResult">
          <a-page-header
            style="border-bottom: 1px solid #ccc;margin-bottom:20px;"
            title="最近编辑"
            sub-title="我编辑过的订单"
          />
          <div
            v-infinite-scroll="infiniteLoadMore"
            :infinite-scroll-disabled="busy"
            :infinite-scroll-distance="10"
          >
            <List :list="timeLineData" />
          </div>
          <div v-if="!timeLineData || timeLineData.length < 1">
            <center> 你是一只纯净的小白</center>
          </div>
        </template>
        <template v-else>
          <a-page-header
            title="搜索结果"
            @back="displaySearchResult=false"
          />
          <List :list="searchResult" />
        </template>
      </div>
    </a-layout-content>
    <a-layout-footer style="text-align: center">
      Ant Design ©2018 Created by Ant UED
    </a-layout-footer>

    <!-- 创建新项目 -->
    <a-modal
      title="创建设计项目"
      v-model="startProjectVisible"
    >
      <a-form-model
        ref="projectForm"
        :model="projectForm"
        :rules="projectRules"
      >
        <a-form-model-item label="订单号" prop="orderId">
          <a-input v-model.trim="projectForm.orderId" @keyup.enter="createProject"/>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="startProjectVisible=false">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="creating" @click="createProject">
          确定
        </a-button>
      </template>
    </a-modal>
  </a-layout>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll'
import userInfo from './UserInfo'
import List from './List'
import projectModel from '@/api/project'
export default {
  directives: { infiniteScroll },
  components: {
    List, userInfo
  },
  data () {
    return {
      timeLineData: [ ],
      loading: false,
      busy: false,
      offset: 0,
      count: 10,
      // 创建项目
      startProjectVisible: false,
      projectForm: {
        orderId: ''
      },
      projectRules: {
        orderId: [{required: true, message: '请填写', trigger: 'blur'}]
      },
      creating: false,
      // 搜索
      keyword: '',
      searching: false,
      displaySearchResult: false,
      searchResult: []
    }
  },
  created () {
    this.update()
  },
  methods: {
    update () {
      const self = this
      this.loading = true
      this.busy = true
      projectModel.currently(this.offset, this.count).then(res => {
        self.loading = false
        if (res.data && res.data.length > 0) {
          self.timeLineData = self.timeLineData.concat(res.data)
          self.busy = false
        }
      }, _ => {
        self.loading = false
        self.busy = false
      })
    },
    // 滚动加载
    infiniteLoadMore () {
      if (this.busy) {
        return
      }
      this.offset += this.count
      this.update()
    },
    startProject () {
      this.startProjectVisible = true
    },
    createProject () {
      const self = this
      this.$refs.projectForm.validate(valid => {
        if (valid) {
          this.creating = true
          // 检查包含订单的项目是否存在
          projectModel.search(this.projectForm.orderId).then(res => {
            if (res.data) {
              // 项目存在
              self.$confirm({
                title: '项目已存在',
                content: '项目已存在, 是否打开编辑?',
                okText: '打开',
                cancelText: '再想想',
                onOk () {
                  self.$router.push(`/design/${res.data.id}`)
                },
                onCancel () {
                  self.creating = false
                }
              })
            } else {
              // 新建项目
              projectModel.create(this.projectForm.orderId).then(res => {
                // 进入编辑
                self.$router.push(`/design/${res.data.id}`)
              }, _ => { self.creating = false })
            }
          }, _ => { self.creating = false })
        }
      })
    },
    onSearch () {
      if (this.keyword) {
        const self = this
        self.searching = true
        projectModel.search(this.keyword).then(res => {
          self.searching = false
          self.searchResult = res.data ? [res.data] : []
          self.displaySearchResult = true
          // TODO display search result
        }, _ => { self.searching = false })
      }
    }
  }
}
</script>

<style scoped>
.logo{width:128px;height:48px;margin:0px 20px 0 0;float: left;}
.logo img{width:100%;}
.timeline-images .ant-card-cover{height: 200px;overflow: hidden;vertical-align: middle;}
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue